import axios from "axios";
import qs from "qs";
import store from "@/store";
import router from "@/router";
// const baseurl = "/";
const baseurl = "https://www.motivactionprofiler.nl/";
// const baseurl = '/womapi/'

const client = {
  auth: false,
  error: "",
  withAuth() {
    client.auth = true;
    return client;
  },
  withoutAuth() {
    client.auth = false;
    return client;
  },
};
const types = ["get", "post", "put", "delete"];
types.forEach((verb) => {
  return new Promise((resolve, reject) => {
    client[verb] = (
      url,
      params = {},
      data = {},
      headers = {},
      responseType = "json"
    ) => {
      return axios({
        method: verb,
        url: baseurl + url,
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "comma" });
        },
        data,
        headers: client.auth
          ? Object.assign(
              {},
              { Authorization: `Bearer ${store.state.auth.token}` },
              headers
            )
          : headers,
        responseType,
      })
        .then((res) => {
          client.auth = false;
          return Promise.resolve(res);
        })
        .catch((error) => {
          if (error.response.status >= 400 && error.response.status <= 505) {
            client.error = error.response.status;
            router.push({ query: { error: client.error } });
          }
          client.auth = false;
          return Promise.reject(error);
        });
    };
  });
});

export default client;
